import { combineReducers } from 'redux';
import mergeWith from 'lodash/merge';
import session from './session';
import profile from './profile';
import correspondence from './correspondence';
import listings from './listings';
import folders from './folders';
import activity from './activity';
import search from './search';
import transaction from './transaction';
import contacts from './contacts';
import { AUTH_LOGOUT } from '../actions/session';



const defaultEntityState = {
    Activities: {},
    Listings: {},
    //ListingsSearch: {},
    Folders: {},
    activity: {}
};

const entities = (state = defaultEntityState, action) => {
    if (action.response && action.response.entities) {
      // if individual activity is updated locate it in state.Activities and update it
      if (action.response.entities.Activity) {
        if (state.Activities[action.response.result.Activity[0]]) {
            // Update an existing entry
            state.Activities[action.response.result.Activity[0]] = 
                action.response.entities.Activity[action.response.result.Activity[0]];

            // if comments count changes and listing exists update its comments count
            // don't check type since it changes based on actions hierarchy. comments count should be correct though
            //if (action.response.entities.Activity[action.response.result.Activity[0]].ActionType === 'ListingCommented' &&
            if (action.response.entities.Activity[action.response.result.Activity[0]].Listing &&
                state.Listings[action.response.entities.Activity[action.response.result.Activity[0]].Listing.Id])
                    state.Listings[action.response.entities.Activity[action.response.result.Activity[0]].Listing.Id].CommentsCount =
                        action.response.entities.Activity[action.response.result.Activity[0]].CommentsCount;
        }
        else {
            // Add the new entry so it merges. This occurs on search page when listing is not in entities
            action.response.entities.Activities = action.response.entities.Activity;
        }
      }

      return mergeWith({}, state, action.response.entities, (src, dest) => {
        // Deep merge arrays
        if (Array.isArray(src)) {
          return dest;
        }
      });
    }
  
    return state;
  };

const appReducer = combineReducers({
    entities,
    session,
    profile,
    correspondence,
    listings,
    folders,
    activity,
    search,
    transaction,
    contacts
});

const rootReducer = (state, action) => {
    if (action.type === AUTH_LOGOUT) {
        state = undefined;
    }

   return appReducer(state, action);
}


export default rootReducer;